"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
const Incoming_1 = require("./Incoming");
const Outgoing_1 = require("./Outgoing");
exports.Event = Object.assign(Object.assign({}, Incoming_1.Incoming), Outgoing_1.Outgoing);
